import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import  NavComp  from './components/mainComp/NavComp';
import FooterComp from './components/mainComp/FooterComp';
import Body from './components/BodyComp/body';
import ContactUs from './components/ContactComp/contactus';
import AboutUs from './components/AboutComp/aboutus';
import WhatsAppButton from './components/Whatsapp/WhatsAppButton';
import ScrollToTop from './ScrollComp/ScrollToTop';
import FAQ from './components/FAQComp/faq';
import MedicalAdvisoryAppliedPsychology from './components/MainDivisionComp/medical-advisory-applied-psychology';
import MedicoLegalMedicalEthics from './components/MainDivisionComp/medico-legal-medical-ethics';
import DigitalHealthAccessoriesWellnessAndSportsBiomechanicsSolutions from './components/MainDivisionComp/digital-health-accessories-wellness-and-sports-biomechanics-solutions';
import BiomedicalEngineeringAndSportsBiomechanicsAdvisory from './components/MainDivisionComp/biomedical-engineering-and-sports-biomechanics-advisory';
import AIHealthInformaticsCsrHealthServices from './components/MainDivisionComp/AI-health-informatics-csr-health-services';
import Booking from './components/BookingComp/booking';





function App() {
  return (
 <Router>
  <ScrollToTop />
      <NavComp />
      <Routes>
        <Route path="/" element={<Body />} />
        <Route path="/contactus" element={<ContactUs />} />
        <Route path="/aboutus" element={<AboutUs />}  />

        <Route path="/medical-advisory-applied-psychology" element={<MedicalAdvisoryAppliedPsychology />} />
        <Route path="/medico-legal-medical-ethics" element={<MedicoLegalMedicalEthics />} />
        <Route path="/digital-health-accessories-wellness-and-sports-biomechanics-solutions" element={<DigitalHealthAccessoriesWellnessAndSportsBiomechanicsSolutions />} />
        <Route path="/biomedical-engineering-and-sports-biomechanics-advisory" element={<BiomedicalEngineeringAndSportsBiomechanicsAdvisory />}  />
        <Route path="/AI-health-informatics-csr-health-services" element={<AIHealthInformaticsCsrHealthServices />}  />
        <Route path="/faq" element={<FAQ />}  />
        <Route path="/booking" element={<Booking />} />



      </Routes>
    
      <FooterComp /> 
      <WhatsAppButton />
    </Router>
  );
}

export default App;
